import { EventEmitter, Injectable, Output } from '@angular/core';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { RestApiService } from '@app-services/rest/rest-api.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { TenantConstant } from '@app-constants/tenant.constant';
import { apisDataCacheKeys, SCDomains, Admin } from '@app-constants/app.constants';
import { take } from 'rxjs/operators';
import { interval } from 'rxjs';
import {environment} from '@app-environments/environment';
import {page_IdFilter} from '@app-constants/app.constants'
import { isUserAdmin } from '@app-helpers/functions';
import * as AWS from 'aws-sdk';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class UserService extends RestApiService{
  branch: any = TenantConstant.branch;
  liveClassUrl=ApiUrlConstant.LIVE_CLASS_API;
  examUrl=ApiUrlConstant.examUrl;
  apiUrl = ApiUrlConstant.apiUrl;
  selfLearnApi = ApiUrlConstant.self_learn_api
  User: any;
  tenant: any = TenantConstant.tenant;
  mobileAndName: any;
  openEditPhoneDialog = new BehaviorSubject<boolean>(false);
  editPhoneDialog = this.openEditPhoneDialog.asObservable();
  omsdevapi:string =ApiUrlConstant.omsdevapi;
  uafapi:string =ApiUrlConstant.uafapi;
  usersapi:string = ApiUrlConstant.usersapi;
  detectBrowserMinMax = new BehaviorSubject<any>({});
  browserMinMax = this.detectBrowserMinMax.asObservable();
  setGoalsBehaviour = new BehaviorSubject<any>(false);
  setGoalsObserable = this.setGoalsBehaviour.asObservable();
  singleGoalBehaviour :Subscription;
  userTimerGoals = 0;
  reffCode;
  multiSubscriber = () => {
    let observers: any = [];
    return (observer: any) => {
      observers.push(observer);
      if (observers.length === 1) {
        const userDetails = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails) as string);
        if(userDetails) {
          observers.forEach((o: any) => {
            o.next(userDetails);
            o.complete();
          })
          observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
        } else {
          const user = this.getUserLocalStorageData();
          const userId = user?.personalDetails?.userId

          this.loadUserDetailsFromServer(userId).subscribe((data: any) => {
            localStorage.setItem(apisDataCacheKeys.userDetails, JSON.stringify(data));
            observers.forEach((o: any) => {
              o.next(data);
              o.complete();
            })
            observers = []; //not a good practice, but for ease of use avoiding call to unsubscribe and doing this
          }, (err: any) => {observer.error(new Error("Issue in fetching user details"))});
        }
      }
      return {unsubscribe() {
        //observers.splice(observers.indexOf(observer), 1);
      }};
    }

  }
  userDataObs: any;

  // tslint:disable-next-line:typedef

  // tslint:disable-next-line:typedef
  setMobileAndName(userDetails: any) {
    localStorage.setItem('mobile_and_name',JSON.stringify(this.mobileAndName = userDetails));
  }

  // tslint:disable-next-line:typedef
  getMobileAndName() {
    //@ts-ignore
    this.mobileAndName =  this.mobileAndName || JSON.parse(localStorage.getItem('mobile_and_name'));
    return this.mobileAndName;
  }

  // tslint:disable-next-line:typedef
  getUserLocalStorageData() {
    let user;
    if(this.User) {
      user = this.User;
    } else if(this.mobileAndName) {
      user = {
        personalDetails: this.mobileAndName
      }
    }
    //  else if(localStorage.getItem(apisDataCacheKeys.userDetails)) {
    //   user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails) as string);
    //   this.updateRequestedUserData( user);
    // }
    else if(localStorage.getItem('mobile_and_name')) {
      const mobile_and_name = JSON.parse(localStorage.getItem('mobile_and_name') as string);
      user = {
        personalDetails: mobile_and_name
      };
    } else user = {personalDetails: {}}
    return user;
  }

  emptyUser() {
    this.User = null;
    this.mobileAndName = null;
  }

  uploadImage(userId: any,obj: any): any {
    const url = this.apiUrl + `/file/upload/${userId}`;
    return this.post(url, obj);
  }

  deleteImage(fileName: any,userId: any): any {
    const url = this.apiUrl + `/file/delete/${fileName}/${userId}`;
    return this.delete(url);
  }

  loadUserDetails(): Observable<any> {
    if(!this.userDataObs) {
      this.userDataObs = new Observable(this.multiSubscriber());
    }
    return this.userDataObs;
  }

  updateRequestedUserData(user: any) {
    localStorage.setItem(apisDataCacheKeys.userDetails, JSON.stringify(user));
  }

  loadUserDetailsFromServer(userId:any): Observable<any> {
    const url = this.apiUrl + `/api/users/${userId}`;
    return this.get(url);
  }

  updateUserDetails(obj: any): Observable<any> {
      const url = this.apiUrl + `/api/users/${obj.userId}`;
      return this.put(url, obj);
  }

  addUserAddress(obj: any, userId): Observable<any> {
    const url = this.apiUrl + `/api/users/${userId}/address`;
    return this.post(url, obj);
  }

  updateUserAddress(obj: any, userId): Observable<any> {
    const url = this.apiUrl + `/api/users/${userId}/address`;
    return this.put(url, obj);
  }
  deleteUserAddress(userId): Observable<any> {
    const url = this.apiUrl + `/api/users/${userId}/address`;
    return this.delete(url);
  }
  addExams(obj: any): Observable<any> {
    const url = this.apiUrl + `/api/exams`;
    return this.post(url, obj);
  }

  addGrade(obj: any): Observable<any> {
    const url = this.apiUrl + `/api/grades`;
    return this.post(url, obj);
  }

  updatePassword(password: any,userId:any): Observable<any> {
    const reqObj = {
      password
    }
    // if (password.)
    const url = this.apiUrl + `/api/users/updatePassword/${userId}`;
    return this.put(url, reqObj);
  }

  profileUpdatePassword(data: any,userId:any): Observable<any> {
    const url = this.apiUrl + `/api/users/updatePassword/${userId}`;
    return this.put(url, data);
  }

  checkMobileNumber(userId:any,phoneNumber: any): Observable<any> {
    const url = this.apiUrl + `/api/users/editphonenumber/${userId}/${phoneNumber}`;
    return this.get(url);
  }

  validateOtpForEditPhone(countryCode:string,phone: any,otp:any): Observable<any> {
    //
    const url = this.apiUrl + `/api/users/validateOtpForEditPhone`;
    const body: any =
        {
          "isdCode": countryCode,
          "phone": phone,
          "userOtp": otp
        }
      return this.put(url, body);
  }

  updateUserPhoneNumber(userId: any, countryCode:string,phone: any,otp:any): Observable<any> {
    //
    const url = this.apiUrl + `/api/users/${userId}/phone`;
    const body: any =
        {
          "isdCode": countryCode,
          "phone": phone,
          "userOtp": otp
        }
      return this.post(url, body);
  }

  setUserTypes(userTypeDetails: any) {
    localStorage.setItem('infinity_usertype',JSON.stringify(userTypeDetails));
  }

  getUserType = () => {
    let userType = localStorage.getItem("infinity_usertype");
    if(userType != null){
      let _userTypeParseData = JSON.parse(userType) || '';

      if(_userTypeParseData?.userTypeId === "" || _userTypeParseData?.userTypeId === null || _userTypeParseData?.userTypeId === undefined) {
        return 1;
      }
      const utId = Number(_userTypeParseData.userTypeId);
      //
      if(utId === 0 || utId) {
        return utId;
      } else {
        return 1;
      }
    } else {
      return 1;
    }
  }

  getUserProfileImg = () => {
    let _proInfo = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    if(_proInfo && _proInfo != undefined && Object.keys(_proInfo).length > 0 && _proInfo.profilePhoto && _proInfo.profilePhoto != '') {
      return _proInfo.profilePhoto;
    } else {
      return '/assets/img/empty-profile.svg'
    }
  }
  gotoSC($event) {
    $event.stopPropagation();
    if(this.tenant == 'srichaitanya') {
      window.location.href = 'https://epraghna.com/studentLogin';
    } else {
      const loc = SCDomains[this.branch] ? SCDomains[this.branch]: SCDomains['production'];
      window.location.href = loc;
    }
  }

  getUserAddressDetails(userId:any): Observable<any> {
    const url = this.apiUrl + `/api/users/${userId}/address`;
    return this.get(url);
  }

  getCoinsDetails(userId:any): Observable<any> {
    const url = this.uafapi + `coins/getCoinsSummaryByUserId?userId=${userId}`;
    return this.get(url);
  }

  getStreaksDetails(userId:any): Observable<any> {
    const url = this.uafapi + `streaks/getStreakSummaryByUserId?userId=${userId}`;
    return this.get(url);
  }

  getExamsForGrade(gradeId:any): Observable<any> {
    const url = this.usersapi + `${gradeId}/exams`;
    return this.get(url);
  }

  getUsergrades(userId:any): Observable<any> {
    const url = this.usersapi + `users/${userId}/grades`;
    return this.get(url);
  }

  addStreaksDetails(userId:any): Observable<any> {
    const url = this.uafapi + `streaks/saveStreakHistory?userId=${userId}`;
    return this.post(url);
  }

  saveRewardHistory(rewardId: number) {
    // if(isUserAdmin(this)) { return;}
    let userData = JSON.parse(localStorage.getItem("user_details_from_server"));
    let rewardData = {
      noOfCoins: 0,
      rewardId: 0,
      rewardType: 'earn',
      type: '',
      userId: userData.userId
    };

    switch (rewardId) {
      case 1:
        rewardData.noOfCoins = 100;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 2:
        rewardData.noOfCoins = 5;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 3:
        rewardData.noOfCoins = 20;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 4:
        rewardData.noOfCoins = 10;
        rewardData.rewardId = rewardId;
        rewardData.type = 'partial';
        break;
      case 5:
        rewardData.noOfCoins = 20;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 6:
        rewardData.noOfCoins = 10;
        rewardData.rewardId = rewardId;
        rewardData.type = 'partial';
        break;
      case 7:
        rewardData.noOfCoins = 40;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 8:
        rewardData.noOfCoins = 20;
        rewardData.rewardId = rewardId;
        rewardData.type = 'partial';
        break;
      case 9:
        rewardData.noOfCoins = 100;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 10:
        rewardData.noOfCoins = 50;
        rewardData.rewardId = rewardId;
        rewardData.type = 'partial';
        break;
      case 11:
        rewardData.noOfCoins = 150;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 12:
        rewardData.noOfCoins = 75;
        rewardData.rewardId = rewardId;
        rewardData.type = 'partial';
        break;
      case 13:
        rewardData.noOfCoins = 10;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 14:
        rewardData.noOfCoins = 20;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 15:
        rewardData.noOfCoins = 20;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 16:
        rewardData.noOfCoins = 100;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 17:
        rewardData.noOfCoins = 500;
        rewardData.rewardId = rewardId;
        rewardData.type = 'partial';
        break;
      case 18:
        rewardData.noOfCoins = 100;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
      case 19:
        rewardData.noOfCoins = 100;
        rewardData.rewardId = rewardId;
        rewardData.type = 'full';
        break;
    }
    const url = this.uafapi + `coins/saveRewardHistory`;
    // return this.post(url, rewardData);
    // let headers = {
    //   'authorization': localStorage.getItem('token')
    // };
    // return this.getByHeaders<any>(url, rewardData, headers);
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, rewardData, _headers);
  }

  saveContactDetails(data:any) {
    const url = this.uafapi + `contact/saveContactUs`;
    return this.post(url, data);
  }

  callTrackingAPI(userId, payload) {
    // if(isUserAdmin(this)) {return;}
    // const url = this.apiUrl + `/api/tracking?userId=`+userId;
    // let page_id = page_IdFilter[payload?.data?.page.toLowerCase()];
    // console.log(page_id);
    const url = this.apiUrl + `/api/tracking/${userId}/userTracking`;
    let headers;
    //  if(page_id){
    //   headers = {
    //     "X-Page_id": page_id || "WEB_IL_SITE",
    //     "X-Platform": "web",
    //     "X-Product": "1",
    //    }
    //  } else {
    //   headers = {
    //     "X-Page": payload?.data?.page || "WEB_IL_SITE",
    //     "X-Platform": "web",
    //     "X-Product": "1",
    //    }
    //  }
    headers = {
      "X-Page": payload?.data?.page || "WEB_IL_SITE",
      "X-Platform": "web",
      "X-Product": "1",
     }
    return this.getByHeaders<any>(url, payload, headers);
  }

  callTrackingAPI2(userId, payload,xpage) {
    const url = this.apiUrl + `/api/tracking/${userId}/userTracking`;
    let headers;
    headers = {
      "X-Page": xpage,
      "X-Platform": "web",
      "X-Product": "1",
      // "X-Landing-page":"LSQ_CUSTOM_EVENTS"
     }
    return this.getByHeaders<any>(url, payload, headers);
  }

  sendSQSMsg(mAccessKeyId,mSecretAccessKey,mQueueUrl,payload){
    AWS.config.update({
      accessKeyId: mAccessKeyId,
      secretAccessKey: mSecretAccessKey,
      region: 'ap-south-1' // Replace with your desired region
   })
   const sqs = new AWS.SQS();
   const params = {
    MessageBody: JSON.stringify(payload), // The message content
    QueueUrl: environment?.branch === 'production'? mQueueUrl?.queue_url: mQueueUrl?.testing_queue_url // Replace with your SQS queue URL
    };

    sqs.sendMessage(params, (err, data) => {
      if (err) { console.log('Error', err);
    } else {
      console.log('Message sent successfully', data.MessageId);
    } });
  }

  sendSQSMsgOptim(mAccessKeyId,mSecretAccessKey,mQueueUrl,payload,eventId){
    AWS.config.update({
      accessKeyId: mAccessKeyId,
      secretAccessKey: mSecretAccessKey,
      region: 'ap-south-1' // Replace with your desired region
   })
   let userData = JSON.parse(
    localStorage.getItem(apisDataCacheKeys.userDetails)
    );
   let firebasePayload :any= {
    "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
    "ActivityEvent": eventId,
    "Fields":payload,
    "FirstName": userData?.firstName,
    "LastName": userData?.lastName,
    "environment": environment?.branch,
    "phone": userData?.phone,
    "productId": 1,
    "type": "Activity"
    }
    if(eventId == 314){
      firebasePayload.Source = "Score Sri Chaitanya";
      firebasePayload.Status ="Active";
      firebasePayload.ActivityEvent_Note = "Score Test"
    }
   const sqs = new AWS.SQS();
   const params = {
    MessageBody: JSON.stringify(firebasePayload), // The message content
    QueueUrl: environment?.branch === 'production'? mQueueUrl?.queue_url: mQueueUrl?.testing_queue_url // Replace with your SQS queue URL
    };

    sqs.sendMessage(params, (err, data) => {
      if (err) { console.log('Error', err);
    } else {
      console.log('Message sent successfully', data.MessageId);
    } });
  }

  getReasonsDetails(): Observable<any> {
    const url = this.uafapi + `contact/getAllContactUsReasonTypes`;
    return this.get(url);
  }

  getGoalDetails(userId: any) {
    const url = this.uafapi + `goals/getActiveGoalByUserId?userId=${userId}`;
    return this.get(url);
  }

  addDailyGoals(data:any) {
    const url = this.uafapi + `goals/saveGoalSetting`;
    const tenant : any = TenantConstant.tenant;
    const _headers = {
      'accesstoken': localStorage.getItem('token'),
      'x-tenant': tenant
    };
    return this.getByHeaders<any>(url, data, _headers);
  }

  endDailyGoals(data)  {
     let xhr = new XMLHttpRequest();
     xhr.open("POST", this.uafapi + `goals/saveGoalSetting`,false);
     xhr.send(JSON.stringify(data));
  }

  talkToLearningExpert(userId, payload) {

    const url = this.apiUrl + `/api/tracking/${userId}/userTracking`;
    const headers = {
      "X-Page": payload?.data?.page,
      "X-Platform": "web",
      "X-Product": "10",
     }
     delete payload?.data?.page;
    return this.getByHeaders<any>(url, payload, headers);
  }

  whatsAppWelcome(payload: any) {
    const url = this.apiUrl + `/api/whatsapp/welcomemessage`;
    const headers = {

    }
    return this.getByHeaders<any>(url, payload, headers);
  }

  updateUserPhone(userId: any, obj: any): Observable<any> {
    const url = this.apiUrl + `/api/users/${userId}/phone`;
    return this.post(url, obj);
  }

  updatePwdWithOTP(obj: any) {
    const url = this.apiUrl + `/api/authentication/updatePassswordWithOtp`;
    return this.post(url, obj);
  }
  setGoalTimeTimer(setGoalTiming){
   if(this.singleGoalBehaviour){
    this.singleGoalBehaviour.unsubscribe()
   }
    const numbers = interval(60000);
        var  takeFourNumbers = numbers.pipe(take(setGoalTiming));
      this.singleGoalBehaviour = takeFourNumbers.subscribe(x =>{
          var spendTime = localStorage.getItem('setGoalSpendingTime') ? JSON.parse(localStorage.getItem('setGoalSpendingTime'))  :(x+1)
          localStorage.setItem('setGoalSpendingTime',JSON.stringify(spendTime+1))
            let one_per = 100 / setGoalTiming;
           this.userTimerGoals  = one_per * (spendTime+1);
           this.setGoalsBehaviour.next(this.userTimerGoals)
          }, ()=>{
          },()=>{
            this.setGoalsBehaviour.complete()
          });
  }

  public setCookie(name: string, value: string, expireDays: number, path: string = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath = path ? `; path=${path}` : '';
    // document.cookie = `${name}=${value}; ${expires}${cpath};  SameSite=Lax`;
    // document.cookie = `${name}=${value};Domain=${environment.routingDomain}; ${expires}${cpath};  SameSite=Lax`;
    let Domain = environment.studentDashboard.split('https://')?.[1]?.replace('/','')
    document.cookie = `${name}=${value};Domain=${Domain}; ${expires}${cpath};  SameSite=Lax`;
  }
  public getCookie(name: string) {
    const ca: Array<string> = decodeURIComponent(document.cookie).split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;

    for (let i  = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) === 0) {
            return c.substring(cookieName.length, c.length);
        }
    }
    return '';
}

setUserRole(userId: any, page: any) {
  const url = this.apiUrl + `/api/users/${userId}/roles`;
  const headers = {
    "X-Page": page || "WEB_IL_SITE",
    "X-Platform": "web",
    "X-Product": "1",
   }
  return this.getByHeaders<any>(url, {roles: [1]}, headers);
}

//?continue learn section api
getIncompleteExam(userId:any){
  console.log('Get In-Complete Exam!');
  const accesstoken=localStorage.getItem('token');
  // liveClassUrl=ApiUrlConstant.LIVE_CLASS_API;
  // examUrl=ApiUrlConstant.examUrl;
  // apiUrl = ApiUrlConstant.apiUrl;
  let newUrl='https://newasmdevapi.devinfinitylearn.in/exam/' //? new api given by himasnshu
  const headers={
    // 'x-tenant':'srichaitanya',
    'access-control-allow-headers': 'x-access-token,Origin,Content-Type,Accept',
    'accesstoken':accesstoken,
  }
  const url =  this.examUrl + `exam/getIncompleteExam`;
  const data = {
    "studentid": userId.toString()
  }
  return this.post(url, data);
  // 'https://asmstagingapi.devinfinitylearn.in/v2/getIncompleteExam/?studentid=290258';
  // return this.getWithHeaders(url,headers);
}

recentClass(studentUAMid:any,grade,examName){
//? give the last rewatched class or last attended live class
console.log('recent class');
// return this.post(url, obj);
const url =  this.liveClassUrl + `students/continue-learning/recent?grade=${grade}&exam=${examName}&studentUAMid=${studentUAMid}`;
// const url ='https://livepreprodapi.devinfinitylearn.in/api/v1/students/continue-learning/recent?grade=12&exam=NEET&studentUAMid=6290350142';
return this.get(url);
}
addUserAsset( body?,id?,type?): Observable<any> {
  const url = this.apiUrl + `/api/userAsssets/users/${id}`;
if(type =='get'){
  return this.get(url);
}else{
  return this.post(url, body);
}
}
getSelfLearnUnfinishedVideos(examId: number, grade: number, userId: number ){
  const url =  this.selfLearnApi + `/api/learn/video/continueLearn?examId=${examId}&gradeId=${grade}&userId=${userId}`;
  // https://selflearnapi.devinfinitylearn.in/api/learn/video/continueLearn?examId=1&gradeId=11&userId=644248
  return this.get(url);
}

setUserRoles(roles: any) {
  localStorage.setItem('user_roles',JSON.stringify(roles));
}
// this.userService.getSelfLearnUnfinishedVideos(this.examId,grade,this.userInfo?.userId).subscribe({
getUserRoles(){
  let user_roles = JSON.parse(localStorage.getItem("user_roles"));
  return user_roles;
}

//?end

//?getting user last added address
getUserLastAddedAddress(userId): Observable<any>{
  const url = this.apiUrl + `/api/users/${userId}/address`;
  return this.get(url);
}

//?update address by user id
updateUserAddressById(obj,addressId:any){
  const url = this.apiUrl + `/api/v1.1/users/${addressId}/address`;
  return this.put(url,obj);
}

// this functions for Score Exam
getStates(){
  const url = this.apiUrl + `/api/Region`;
  return this.get(url);
}
getDistricts(id){
  const url = this.apiUrl+`/api/${id}/districts`;
  return this.get(url);
}
getCitys(id){
  const url = this.apiUrl+`/api/${id}/citys`;
  return this.get(url);
}
getCenter(id){
  const url = this.apiUrl+`/api/${id}/center`;
  return this.get(url);
}
getCityByPincode(pincode:number){
  const url = this.apiUrl+`/api/users/${pincode}/getRegionDistrictCityByPinCode`;
  return this.get(url);
}
}
